// extracted by mini-css-extract-plugin
var _1 = "zzWZYCOh";
var _2 = "zzWZYCOh";
export { _1 as "opening-hours", _2 as "openingHours" }
